import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  ViewChild,
  ElementRef,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { EventBusService } from '../../../services/EventBusService';
import { SearchFilterItem } from '../../../models/SearchFilterItem';
import { ClearFilterService } from '../../../services/clear-filter.service';

import numeral from 'numeral';

declare var jQuery: any;

@Component({
  selector: 'pix-dropdown-range-slider3',
  templateUrl: './dropdown-range-slider3.component.html',
  styleUrls: ['./dropdown-range-slider3.component.css']
})
export class DropdownRangeSliderComponent3
  implements AfterViewInit, OnInit, OnChanges
{
  @Input() fromText: string = 'From';
  @Input() toText: string = 'To';
  @Input() tab: string;
  @Input() step: number = 1;
  @Input() title: string;
  @Input() param: string;
  @Input() minValue: number;
  @Input() maxValue: number;
  @Input() iconHtml: string;
  @Input() isPercent: boolean = false;
  @Input() dropdownPosition: string = 'left';
  @Input() fromValue: number;
  @Input() toValue: number;
  @Input() disabled: boolean;
  @Output() onRangeChanged = new EventEmitter<SearchFilterItem>();
  @Output() close = new EventEmitter<any>();

  valuesChange: boolean;

  @Input() initMaxValue: number;
  @Input() initMinValue: number;

  initFromValue: number;
  initToValue: number;

  prevMaxValue: number = -1;
  prevMinValue: number = -1;

  //@ViewChild('dropdown') dropdownEl: ElementRef;
  //@ViewChild('dropdownMenu') dropdownMenuEl: ElementRef;
  @ViewChild('rangeslider') rangeSlider: ElementRef;
  @ViewChild('minField') minField: ElementRef;

  slider: any;

  constructor(
    public eventBus: EventBusService,
    private clearFilterService: ClearFilterService
  ) {
    this.clearFilterService.clearFilterConfirmed$.subscribe(filterType => {
      if (filterType.param === this.param) {
        this.maxValue = this.initMaxValue;
        this.minValue = this.initMinValue;
        this.fromValue = this.initMinValue;
        this.toValue = this.initMaxValue;
        this.prevMaxValue = -1; //this.initMaxValue;
        this.prevMinValue = -1; //this.initMinValue;
        this.slider.update({
          from: this.minValue,
          to: this.maxValue
        });
      }
    });
  }

  ngOnInit() {
    this.initMaxValue = this.maxValue;
    this.initMinValue = this.minValue;

    this.initFromValue = this.fromValue;
    this.initToValue = this.toValue;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initMaxValue && changes.initMaxValue.currentValue) {
      this.initMaxValue = changes.initMaxValue.currentValue;

      if (this.toValue == 5000) {
        // replace default value when no param is provided
        this.toValue = this.initMaxValue;
      }

      if (this.initMaxValue > 10000) {
        this.step = Math.round(this.initMaxValue / 1000);
      }

      if (this.slider) {
        this.slider.update({
          max: this.initMaxValue,
          to: this.toValue,
          step: this.step
        });
      }
    }
  }

  rangeChange(event: any) {
    if (this.toValue > this.initMaxValue) {
      this.toValue = this.initMaxValue;
    }

    if (this.fromValue > this.initMaxValue) {
      this.fromValue = this.initMaxValue;
    }

    if (this.fromValue < this.initMinValue) {
      this.fromValue = this.initMinValue;
    }
    if (
      this.fromValue <= this.toValue &&
      this.toValue >= this.fromValue &&
      (this.prevMinValue != this.fromValue || this.prevMaxValue != this.toValue)
    ) {
      let text = '';
      if (this.isPercent) {
        text = `${this.title}: ${this.fromValue}% - ${this.toValue}%`;
      } else {
        let fromv =
          this.fromValue > 999
            ? numeral(this.fromValue).format('0a')
            : this.fromValue;
        let tov =
          this.toValue > 999
            ? numeral(this.toValue).format('0a')
            : this.toValue;

        let ftext = `${fromv} - ${tov}`;
        text = `${this.title}: ${ftext.toUpperCase()}`;
      }
      let fMinValue = this.isPercent ? this.fromValue / 100 : this.fromValue;
      let fMaxValue = this.isPercent ? this.toValue / 100 : this.toValue;

      this.onRangeChanged.emit({
        event: event,
        tab: this.tab,
        aggregate: true,
        iconHtml: this.iconHtml,
        param: this.param,
        text: text,
        values: [`[${fMinValue},${fMaxValue}]`]
      });

      this.prevMinValue = this.fromValue;
      this.prevMaxValue = this.toValue;

      this.slider.update({
        from: this.fromValue,
        to: this.toValue
      });
    }
  }

  ngAfterViewInit(): void {
    setTimeout(fn => {
      jQuery(this.rangeSlider.nativeElement).ionRangeSlider({
        type: 'double',
        hide_from_to: true,
        hide_min_max: true,
        min: this.minValue,
        max: this.maxValue,
        from: this.fromValue > 0 ? this.fromValue : this.minValue,
        to: this.toValue > 0 ? this.toValue : this.maxValue,
        step: this.step,
        extra_classes: 'pix-slider',
        onChange: data => {
          this.fromValue = data['from'];
          this.toValue = data['to'];
          // this.rangeChange();

          if (
            this.fromValue !== this.initFromValue ||
            this.toValue !== this.initToValue
          ) {
            this.valuesChange = true;
            jQuery(this.rangeSlider.nativeElement).parent().removeClass('idle');
          } else {
            this.valuesChange = false;
            jQuery(this.rangeSlider.nativeElement).parent().addClass('idle');
          }
        }
      });

      this.slider = jQuery(this.rangeSlider.nativeElement).data(
        'ionRangeSlider'
      );
      this.slider.dragging = false;
    }, 100);
  }

  triggerKeyEnter(event: any) {
    let e = jQuery.Event('keydown');
    e.which = 13;
    jQuery(this.minField.nativeElement).focus();
    jQuery(this.minField.nativeElement).trigger(
      jQuery.Event('keydown', { which: 13 })
    );
    this.rangeChange(event);
  }

  closeClick(event) {
    this.close.emit(event);
  }
}
